export default function ScrollToTopPagination() {
    document.getElementsByClassName("main-container")[0].scrollTo(0, 0)
}
